export { default as Gallery } from './gallery'


// WEBPACK FOOTER //
// ./src/modules/images/index.js